import { reducerServiceTypeActions } from './serviceType.reducer';
import * as selectors from './serviceType.selector';
export { default } from './serviceType.reducer';

export const serviceTypeActions = reducerServiceTypeActions;
export const serviceTypeSelectors = selectors;
